export default __webpack_public_path__ + "static/abcbank-renewal-d52ca38d0d37b7df8abc7a5a4bb7d768.png";